import {TaxesAndSalesSection} from './TaxesAndSalesSection'
import {PRODUCT_REVIEW_TAXES_AND_SALES_SECTIONS} from './taxesAndSalesDataMap'

export const TaxesAndSalesTab = () => {
  return (
    <div className="grid grid-cols-2 items-start gap-3">
      {PRODUCT_REVIEW_TAXES_AND_SALES_SECTIONS.map(section => (
        <TaxesAndSalesSection key={section.id} section={section} />
      ))}
    </div>
  )
}
